import { FC } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import useHoverOrTouch from 'src/hooks/events/useHoverAndTouch';
import { ESize } from 'src/styles/theme/utils/enums';
import { NGTextEx, StyledLabel } from './AnimatedCookieDescription.styles';
import { IAnimatedCookieDescription } from './AnimatedCookieDescription.type';

const AnimatedCookieDescription: FC<IAnimatedCookieDescription> = ({ htmlFor, legalDescription, loreDescription }) => {
	const { isHoveringOrTouching, touchOrHoverHandlers } = useHoverOrTouch();

	return (
		<StyledLabel data-cy={`${htmlFor}-description`} htmlFor={htmlFor} {...touchOrHoverHandlers}>
			<TransitionGroup>
				<CSSTransition
					key={isHoveringOrTouching ? 'legalDescription' : 'loreDescription'}
					timeout={200}
					classNames='fade'
				>
					{isHoveringOrTouching ? (
						<NGTextEx size={ESize.s}>{legalDescription}</NGTextEx>
					) : (
						<NGTextEx size={ESize.s}>{loreDescription}</NGTextEx>
					)}
				</CSSTransition>
			</TransitionGroup>
		</StyledLabel>
	);
};

export { AnimatedCookieDescription };
